const preview = {
  preview: {
    name: 'preview',
    componentTypes: ['navigate', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    formData: (params) => {
      return {
        card: params.state.currentStep.label,
        files: {
          hasPagination: params.state.fileType === 'pdf',
          fileType: params.state.fileType
        }
      }
    }
  }
}
export default preview
